import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/statistics.json";

export const useStatistics = () => useSourceFlowCollection(data);

export default useStatistics;
